import { useParams } from "react-router-dom";
import { SearchX } from "lucide-react";

import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/empty-state";
import { DetailSkeleton } from "@/components/loading-skeletons";
import { PageHeader } from "@/components/layout/page-header";
import { ServiceForm } from "@/components/service/service-form";
import { useServiceQuery } from "@/hooks/use-services";

export function EditServicePage() {
  const { id } = useParams<{ id: string }>();
  const { data: service, isLoading, error, refetch } = useServiceQuery(id!);

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader title="Edit Service" />
        <DetailSkeleton withTitle={false} />
      </div>
    );
  }

  if (error || !service) {
    return (
      <div className="flex flex-1 flex-col gap-6">
        <PageHeader title="Edit Service" />
        <EmptyState
          icon={SearchX}
          title="Service Not Found"
          description="The service you are looking for does not exist."
        >
          <Button variant="outline" size="sm" onClick={() => refetch()}>
            Retry
          </Button>
        </EmptyState>
      </div>
    );
  }

  return <ServiceForm mode="edit" service={service} />;
}
